__turbopack_context__.v({
  "desktopCta": "Header-module-scss-module__R6eCJW__desktopCta",
  "logo": "Header-module-scss-module__R6eCJW__logo",
  "logoImg": "Header-module-scss-module__R6eCJW__logoImg",
  "mainHeader": "Header-module-scss-module__R6eCJW__mainHeader",
  "mainMenu": "Header-module-scss-module__R6eCJW__mainMenu",
  "mainNav": "Header-module-scss-module__R6eCJW__mainNav",
  "menuToggle": "Header-module-scss-module__R6eCJW__menuToggle",
  "menuToggleOpen": "Header-module-scss-module__R6eCJW__menuToggleOpen",
  "mobileMenu": "Header-module-scss-module__R6eCJW__mobileMenu",
  "mobileMenuOpen": "Header-module-scss-module__R6eCJW__mobileMenuOpen",
  "mobileSubmenu": "Header-module-scss-module__R6eCJW__mobileSubmenu",
  "nav": "Header-module-scss-module__R6eCJW__nav",
  "navItem": "Header-module-scss-module__R6eCJW__navItem",
  "navLink": "Header-module-scss-module__R6eCJW__navLink",
  "navLinkCurrent": "Header-module-scss-module__R6eCJW__navLinkCurrent",
  "navSubLink": "Header-module-scss-module__R6eCJW__navSubLink",
  "searchToggle": "Header-module-scss-module__R6eCJW__searchToggle",
  "searchToggleMob": "Header-module-scss-module__R6eCJW__searchToggleMob",
  "skipLink": "Header-module-scss-module__R6eCJW__skipLink",
  "subMenu": "Header-module-scss-module__R6eCJW__subMenu",
});
